/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const StocktakePrepareService = {
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async SaveStocktake(payload) {
    var url = `api/Save_PrepareStocktake`;
    return await ApiService.post(url, payload);
  },

  async getActiveAccountingPeriodStartDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'STK'`,
      orderby: "StartDate",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { StocktakePrepareService };
